export default "__VITE_ASSET__IHF4l4Vu__"